import React, { useEffect, useState } from 'react';
import styles from './ReferenceMolecule.module.css';
import { useFetchApplicationByApplicantAndApplication } from '../../../../Hooks/SingleApplicant';
import { useParams } from 'react-router-dom';
import TextContainer from '../../../Atoms/CustomizedAtoms/TextContainer';
import MoreButton from '../../Custom/PopOver/MoreButton';
import ReferenceDocumentIcon from '../../../../assets/Imagess/refrenceDocumentIcon.svg';
import moreIcon from '../../../../assets/Imagess/more-vet-svgrepo-com 1.svg';
import downloadIcon from '../../../../assets/Imagess/downloadIcon.svg';
import PopOver from '../../Custom/PopOver/PopOver';
import { useDownloadReferenceDocument } from '../../../../Hooks/Reference';
import { toast } from 'react-toastify';
import NoDataComponent from '../../Custom/NoData/NoDataComponent';
const ReferenceMolecule = ({ data }) => {
  const { id } = useParams();
  const [applicationId, setApplicationId] = useState(
    data?.applications[0]?.applicationId
  );
  const { data: applicationDataById } =
    useFetchApplicationByApplicantAndApplication(id, applicationId);

  const downloadReferenceDocument = useDownloadReferenceDocument();
  useEffect(() => {
    {
      data?.applications ??
        setApplicationId(data?.applications[0]?.applicationId);
    }
  }, [data]);

  const handleDownload = async (doc) => {
    try {
      const data = await downloadReferenceDocument.mutateAsync(doc);
      const url = window.URL.createObjectURL(data.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Reference Document';
      link.click();
      window.URL.revokeObjectURL(url);
      toast.success('Document is Downloaded');
    } catch (error) {
      console.error('Error downloading file:', error);
      toast.error('File has not been submitted yet');
    }
  };
  const getLabelFromValue = (value) => {
    switch (value) {
      case 0:
        return '0-6 months';
      case 1:
        return '6-12 months';
      case 2:
        return '1-2 years';
      case 3:
        return '2 or more years';
      case 4:
        return 'Supervisor';
      case 5:
        return 'Colleague';
      case 6:
        return 'Other';
      case 7:
        return 'Unable To Judge';
      case 8:
        return 'Below Average';
      case 9:
        return 'Average';
      case 10:
        return 'Good';
      case 11:
        return 'Very Good';
      case 12:
        return 'Excellent';
      case 13:
        return 'Outstanding';
      case 14:
        return 'Exceptional';
      default:
        return 'Unknown';
    }
  };
  const dataOutput = [
    {
      title: 'How long you know the applicant?',
      item: 'knowApplicant',
    },
    {
      title: 'What context?',
      item: 'knowContext',
    },
    {
      title: 'Intellectual Ability',
      item: 'intellectualAbility',
    },
    {
      title: 'Analytical Ability',
      item: 'analyticalAbility',
    },
    {
      title: 'Leadership Potential',
      item: 'leadershipPotential',
    },
    {
      title: 'Teamwork Skills',
      item: 'teamworkSkills',
    },
    {
      title: 'Planning Skills',
      item: 'planningSkills',
    },
    {
      title: 'Communication Skill',
      item: 'communicationSkills',
    },
    {
      title: 'Overall',
      item: 'overall',
    },
    {
      title: 'Behavior traits',
      item: 'behaviorTraits',
      flag: 1,
    },
    {
      title: 'Additional Comments',
      item: 'additionalComments',
      flag: 1,
    },

    {
      title: 'Evaluator Name',
      item: 'evaluatorName',
      flag: 1,
    },
    {
      title: 'Title/Position',
      item: 'title',
      flag: 1,
    },
    {
      title: 'Company',
      item: 'company',
      flag: 1,
    },
  ];
  return (
    <>
      {data?.applicantReferance?.length === 0 ? (
        <NoDataComponent text="Reference" />
      ) : (
        data?.applicantReferance?.map((ref) => {
          if (ref?.referanceEmail == null) {
            return;
          }
          return (
            <div className={styles['reference-container']}>
              <div className={styles['reference']}>
                <div className={styles['reference-subcontainer']}>
                  <TextContainer
                    title="Title"
                    data={ref?.referanceTitle_Display}
                    required={false}
                  />
                  <TextContainer
                    title="Name"
                    data={ref?.referanceName}
                    required={false}
                  />
                  <TextContainer
                    title="Email"
                    data={ref?.referanceEmail}
                    required={false}
                  />{' '}
                  <TextContainer
                    title="How do you know the reference: "
                    data={ref?.knowTheReferance}
                  />
                </div>

                <div className={styles['document-container']}>
                  <h2>Letter of Recomendation</h2>
                  <div className={styles['document-subcontainer']}>
                    {console.log('Vdsvsdkjnv', ref)}
                    {ref?.applicantReferanceId &&
                    ref?.referanceName != null &&
                    ref?.uploadedDocumentOn != null ? (
                      <>
                        {' '}
                        <div className={styles['document']}>
                          <img
                            src={ReferenceDocumentIcon}
                            alt="reference document"
                          />
                          <div>
                            <h2>Reference.pdf</h2>
                            <h4>Reference</h4>
                          </div>
                        </div>
                        <MoreButton
                          icon={moreIcon}
                          profileImg="profile-img"
                          width="200px"
                          imgWidth="25px"
                          imgHeight="20px"
                          top="1rem"
                          toolTipText="More"
                        >
                          <PopOver
                            stop
                            info={[
                              {
                                title: 'Download',
                                icon: downloadIcon,
                                handleFunction: () =>
                                  handleDownload(ref?.applicantReferanceId),
                              },
                              // {
                              //   title: "Print",
                              //   icon: printIcon,
                              // },
                              // {
                              //   title: "Delete",
                              //   icon: deleteicon,
                              // },
                            ]}
                          />
                        </MoreButton>
                      </>
                    ) : (
                      <TextContainer attachement={true} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
      {data?.applicantReferenceForm?.length > 0 ? (
        <div className={styles['reference-container']}>
          <h3>Recommendation Form</h3>
          {data?.applicantReferenceForm?.map((item) => {
            return (
              <div className={styles['reference']}>
                <div className={styles['reference-subcontainer']}>
                  {dataOutput?.map((output) => {
                    return (
                      <TextContainer
                        title={output.title}
                        data={
                          output?.flag === 1
                            ? item[output.item]
                            : getLabelFromValue(item[output.item])
                        }
                        required={false}
                      />
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export default ReferenceMolecule;
